import { render, staticRenderFns } from "./ShowLifeStyle.vue?vue&type=template&id=336da7a0"
import script from "./ShowLifeStyle.vue?vue&type=script&lang=js"
export * from "./ShowLifeStyle.vue?vue&type=script&lang=js"
import style0 from "./ShowLifeStyle.vue?vue&type=style&index=0&id=336da7a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports